import React, { useState } from 'react';
import './customersignup.scss';
import axios from 'axios';
import { toast } from 'react-toastify';

const CustomerSignup = () => {

        const fetchingTenant = window.location.hostname.split(".")[0];
    const apiPort = process.env.REACT_APP_API_PROTOCOL;
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    password: '',
    address: '',
    city: '',
    state: '',
    country: '',
    pincode: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log(formData);
//   };


       const handleSubmit = async (e) => {
        e.preventDefault()

        try {
            const response = await axios.post(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/signup/`,
                
                    formData,
                // {
                //     headers: {
                //         Authorization: `Bearer ${token}`,
                //     },
                // }
            );
            console.log(response, "sdcsccdsc")
            if (response?.data) {
                toast.success("Otp sent successfully");
            }

            console.log("Profile updated successfully:", response.data);
        } catch (error) {
            console.error("Error updating profile:", error);
            toast.error("An error occured");
        }
    };

  return (
    <div className="signup-container">
      <h2>Customer Signup</h2>
      <form onSubmit={handleSubmit} className="signup-form">
        {[
          { name: 'first_name', placeholder: 'First Name' },
          { name: 'last_name', placeholder: 'Last Name' },
          { name: 'email', placeholder: 'Email', type: 'email' },
          { name: 'phone', placeholder: 'Phone' },
          { name: 'password', placeholder: 'Password', type: 'password' },
          { name: 'city', placeholder: 'City' },
          { name: 'state', placeholder: 'State' },
          { name: 'country', placeholder: 'Country' },
          { name: 'pincode', placeholder: 'Pincode' }
        ].map(({ name, placeholder, type = 'text' }) => (
          <div className="form-group" key={name}>
            <input
              type={type}
              name={name}
              placeholder={placeholder}
              value={formData[name]}
              onChange={handleChange}
            />
          </div>
        ))}

        <div className="form-group">
          <textarea
            name="address"
            placeholder="Address"
            value={formData.address}
            onChange={handleChange}
          />
        </div>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default CustomerSignup;
